import * as THREE from 'three'
import React, { useRef } from 'react'
import { extend, useThree, useFrame } from 'react-three-fiber'
import { FirstPersonControls } from 'three/examples/jsm/controls/FirstPersonControls'
import { MixedControls } from './utility/MixedControls'
import clamp from './utility/clamp'
import isMobile from './utility/mobile'
import config from './config'

extend({ FirstPersonControls })
extend({ MixedControls })

const Controls = (props) => {
	const { camera, scene, gl: { domElement } } = useThree()
	const ref = useRef()
	const isGyro = isMobile()
	const raycaster = new THREE.Raycaster()
	let prevPos = new THREE.Vector3(camera.position)

	const detectCollision = () => {
		let collision = false

		scene.traverse((object) => {
			if (collision ||
				!config.collision.isTarget(object.name) ||
				!object.geometry.isBufferGeometry) {
				return
			}

			for (let i = 0; i < config.collision.viewVolume.length; i++) {
				if (collision) {
					break
				}

				raycaster.setFromCamera(config.collision.viewVolume[i], camera)
				const intersects = raycaster.intersectObject(object)

				for (let j = 0; j < intersects.length; j++) {
					if (intersects[j].distance < config.collision.distance) {
						collision = true
						break
					}
				}
			}
		})

		return collision
	}

	useFrame((state, delta) => {
		ref.current.update(delta)

		if (isGyro) {
			ref.current.updateMove(delta)

			let angle = 0

			if (camera.rotation.x > 0) {
				angle = config.camera.virticalMax / 90
			} else {
				// スマホはPCより角度大きめじゃないとわかりずらい
				angle = 1.8 * config.camera.virticalMin / 90
			}

			angle = clamp(angle, -1, 1)

			camera.rotation.x = camera.rotation.x * angle
			camera.rotation.z = camera.rotation.z * 0.05 // カメラの回転はしない(ビルボードが追従してしまう)
		}

		if (detectCollision()) {
			camera.position.copy(prevPos)
		} else {
			camera.position.set(
				clamp(camera.position.x, config.stage.xMin, config.stage.xMax),
				config.stage.y,
				clamp(camera.position.z, config.stage.zMin, config.stage.zMax)
			)

			prevPos.copy(camera.position)
		}
	})

	if (isGyro) {
		return (
			<mixedControls
				ref={ref}
				args={[camera, domElement]}
				{...props}
			/>
		)
	}

	return (
		<firstPersonControls
			ref={ref}
			args={[camera, domElement]}
			noFly={true}
			{...props}
		/>
	)
}

export default Controls